import React from 'react';
import { useTranslate } from '@bynder/localization';
import { IconPrint } from '@bynder/icons';
import { Flex } from '@bynder/design-system';
import { iconSizeLarge } from '../../helpers/iconSizes';

/*
 * bynder-core/byndercore/lib/header/primary_cta.py
 */
export function ConvertToPDFButton() {
	const { translate } = useTranslate();
	const chapterType = window.location.pathname.split('/')[2];

	return (
		<ul className="cta-main-container" id="uploadContainer">
			<li>
				<a
					id="styleguide-button-export"
					className="cta-main"
					href="#"
					data-chapter-type={chapterType}
				>
					<Flex gap="2" alignItems="center">
						<IconPrint size={iconSizeLarge} /> {translate('convertGuidelines')}
					</Flex>
				</a>
			</li>
		</ul>
	);
}
